import {invalidateQueries, q} from "../../state";
import {UpdateWatcherTrigger, WatcherPreferences} from "../../Types";
import jsonApi from "../jsonApi";

import {CURRENT_REGION} from "../../utils/region";

export async function get_(): Promise<WatcherPreferences> {
  return await jsonApi.get<WatcherPreferences>(`/region/${CURRENT_REGION}/api/watcher_preferences`);
}

export async function getAccount(): Promise<WatcherPreferences> {
  return await jsonApi.get<WatcherPreferences>(`/region/${CURRENT_REGION}/api/watcher_preferences/account`);
}

export async function updateUserPreference(update: UpdateWatcherTrigger) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/watcher_preferences`, update);
  await invalidateQueries([q.userWatcherPreferences.filter()]);
  return res;
}

export async function updateAccountPreference(update: UpdateWatcherTrigger) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/watcher_preferences/account`, update);
  await invalidateQueries([q.accountWatcherPreferences.filter(), q.userWatcherPreferences.filter()]);
  return res;
}
